<template>
    <g fill="" fill-rule="evenodd">
        <g>
            <g>
                <g transform="translate(-39 -75) translate(39 75)">
                    <rect width="55" height="24" fill="#678099" rx="12"/>
                    <circle cx="12" cy="12" r="7" fill="#FFF"/>
                </g>
                <text fill="#FFF" font-family="OpenSans-Bold, Open Sans" font-size="11" font-weight="bold" transform="translate(-39 -75) translate(39 75)">
                    <tspan x="25" y="16">Off</tspan>
                </text>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'switcherNotLiveAdUnitIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 55 24');
    }
};
</script>
